module.exports = __webpack_public_path__ + "media/images/default_community_image_main-d202261f131abe75793445ba386bf0ff.png";